import { CommonModule } from "@angular/common";
import { Component, OnInit, forwardRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { MoneyPipe } from "src/app/pipes/money/money";
import { UserProvider } from "src/app/services/user/user";
@Component({
  selector: "app-contribuicoes-detalhes",
  templateUrl: "./contribuicoes-detalhes.page.html",
  styleUrls: ["./contribuicoes-detalhes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    MoneyPipe,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class ContribuicoesDetalhesPage implements OnInit {
  detalhes: any = [];
  idPessoa: any;
  idPlanoContas: any;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    public userProvider: UserProvider,
    public modalCtrl: ModalController
  ) {
    this.idPessoa = this.navParams.get("idPessoa");
    this.idPlanoContas = this.navParams.get("idPlanoContas");
    this.userProvider
      .contribuicoesDetalhes(this.idPessoa, this.idPlanoContas)
      .subscribe({
        next: (data) => {
          this.detalhes = data;

          setTimeout(() => {
            this.loaded = true;
          }, 1000);
        },
        error: (err) => {
          console.error("Erro:", err);
          this.loaded = true;
        },
      });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
